"use client";
import { useState } from "react";

import { motion } from "framer-motion";

import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';


export default function ITemMenu() {
  return (
    <header>

      <Navbar className="">
        <Container>
          <Navbar.Brand href="/" >
            <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{
              duration: 0.25,
              ease: "easeOut"
            }}
            className="logo"
            >
              NP
            </motion.div>
          </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">
            <Navbar.Text className="px-3">
              <a href="#experience">
                <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{
                  duration: 0.45,
                  ease: "easeOut"
                }}>
                  Experience
                </motion.div>
              </a>
            </Navbar.Text>
            <Navbar.Text className="px-3">
              <a href="#work">
                <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{
                  duration: 0.65,
                  ease: "easeOut"
                }}>
                  Work
                </motion.div>
              </a>
            </Navbar.Text>
            <Navbar.Text className="px-3">
              <a href="#contact">
                <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{
                  duration: 0.85,
                  ease: "easeOut"
                }}>Contact
                </motion.div>
              </a>
            </Navbar.Text>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>

  );
}
